import styled, { css } from 'styled-components';

export const HeaderRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 12px;
`;

export const ActionRow = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	flex-shrink: 0;
`;

export const IconButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 26px;
	height: 26px;
	padding: 0;
	border-radius: 6px;
	border: 1px solid transparent;
	background-color: transparent;
	color: ${({ theme }) => theme.gray[600]};
	transition: all 0.15s ease;

	&:hover:not(:disabled) {
		background-color: ${({ theme }) => theme.gray[100]};
		color: ${({ theme }) => theme.gray[1000]};
		border-color: ${({ theme }) => theme.gray[200]};
	}

	&:disabled {
		opacity: 0.4;
	}
`;

export const NameInputSlot = styled.div`
	flex: 1;
	max-width: 320px;
`;

export const AddCard = styled.div<{ $isDragging?: boolean }>`
	border: 1px dashed ${({ theme }) => theme.gray[400]};
	border-radius: 10px;
	background-color: ${({ theme }) => theme.gray[0]};
	transition: border-color 0.15s ease, background-color 0.15s ease;

	${({ $isDragging, theme }) =>
		$isDragging &&
		css`
			border-color: ${theme.blue[500]};
			background-color: ${theme.blue[300]}33;
		`}
	margin-bottom: 16px;
`;

export const AddCardBody = styled.div`
	display: flex;
	flex-direction: column;
`;

export const AddRow = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 20px 24px;
	color: ${({ theme }) => theme.gray[700]};
	transition: background-color 0.15s ease, color 0.15s ease;

	&:hover {
		background-color: ${({ theme }) => theme.gray[100]};
		color: ${({ theme }) => theme.gray[1000]};
	}
	border-radius: 10px;
`;

export const AddRowLabel = styled.span`
	font-size: 14px;
	font-weight: 500;
`;

export const AddRowSubtitle = styled.span`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	margin-left: auto;
`;

export const AddDivider = styled.div`
	height: 1px;
	background-color: ${({ theme }) => theme.gray[200]};
	margin: 0 24px;
`;
